import { type LoyaltyUser, type LoyaltyUserUpdateInfo } from "@koala/sdk";
import { Component } from "react";
import { type ConnectedProps, connect } from "react-redux";
import {
  Field,
  getFormValues,
  type InjectedFormProps,
  reduxForm,
} from "redux-form";
import {
  StyledCancelAndSubmitButtons,
  StyledCancelEdit,
  StyledForm,
  StyledFormField,
  StyledInlineFormContainer,
  StyledLinkButton,
} from "../styles";
import PrimaryButton from "@/components/checkout/uielements/primaryButton";
import StringAccessor from "@/components/cmsConfig/stringAccessor";
import { ReduxFormField } from "@/components/uielements/form-fields";
import { type RootState } from "@/types/app";
import { editUserValidator as validate } from "@/validators/authValidators";

interface Props extends ReduxProps, InjectedFormProps<any, Props> {
  updateMe: (params: Partial<LoyaltyUserUpdateInfo>) => void;
  me?: LoyaltyUser;
}

class UpdatePasswordForm extends Component<Props> {
  // @ts-expect-error improve form value typing.
  handleSubmitForm = (values) => {
    this.props.updateMe(values);
    this.props.reset();
  };
  render() {
    const { handleSubmit, pristine, reset } = this.props;
    return (
      <StyledForm onSubmit={handleSubmit(this.handleSubmitForm)}>
        <StyledInlineFormContainer>
          <StyledFormField>
            <Field
              name="current_password"
              type="password"
              placeholder="Current Password"
              autoComplete="off"
              component={ReduxFormField}
            />
          </StyledFormField>
          <StyledFormField>
            <Field
              name="password"
              type="password"
              placeholder="New Password"
              autoComplete="off"
              component={ReduxFormField}
            />
          </StyledFormField>
          <StyledFormField>
            <Field
              name="password_confirmation"
              type="password"
              placeholder="Confirm New Password"
              autoComplete="off"
              component={ReduxFormField}
            />
          </StyledFormField>
        </StyledInlineFormContainer>
        <StyledCancelAndSubmitButtons>
          {/* Clear button */}
          {!pristine && (
            <StyledCancelEdit>
              <StyledLinkButton
                type="button"
                onClick={() => reset()}
                aria-label="Clear password form"
              >
                Clear
              </StyledLinkButton>
            </StyledCancelEdit>
          )}
          {/* Submit Button */}
          <PrimaryButton
            type="submit"
            theme="secondary"
            submitting={false}
            handleClick={() => null}
            minWidth={150}
            aria-label="Submit Password Form"
          >
            <StringAccessor accessor="account.change_password_button" />
          </PrimaryButton>
        </StyledCancelAndSubmitButtons>
      </StyledForm>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  formValues: getFormValues("update-password")(state),
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default reduxForm<LoyaltyUserUpdateInfo, Props>({
  form: "update-password",
  validate,
})(connector(UpdatePasswordForm));
